import React from 'react'
import AppBarComponent from '../newTestPrepDesign/component/AppBar';
import { Box, Container, Divider, Typography } from '@mui/material';

function PrivacyPolicyPage() {
    const sectionTitleStyle = {
    fontWeight: 'bold',
    color: '#228B22',
    fontSize: "16px"
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    listStyleType: 'disc',
};

  return (
    <>
     <Box>
        <AppBarComponent />
    </Box> 
    <Container maxWidth="md" sx={{ py: 4, mt: 12 }}>
      <Typography variant="h2" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Last Updated:</strong> 07/01/2025
      </Typography>

      <Typography paragraph>
        Welcome to <strong>STM</strong>, a trusted platform dedicated to helping students prepare for international exams such as IELTS, PTE, GRE, GMAT, and SAT. Your privacy is important to us, and this Privacy Policy explains how we collect, use, store, and protect your personal information when you access our website or use our services.
      </Typography>
      <Typography paragraph>
        By using our website <a href="https://siectestmasters.com" target="_blank" rel="noopener noreferrer">https://siectestmasters.com</a> or registering for any of our services, you agree to the terms of this Privacy Policy.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h5" sx={sectionTitleStyle}gutterBottom>1. Information We Collect</Typography>
      <Typography variant="subtitle1" sx={sectionTitleStyle} gutterBottom>a. Personal Information</Typography>
      <ul style={listStyle}>
        <li>Full Name</li>
        <li>Email Address</li>
        <li>Mobile Number</li>
        <li>Date of Birth</li>
        <li>Educational Qualifications</li>
        <li>Course Preferences</li>
        <li>Country or City of Residence</li>
      </ul>

      <Typography variant="subtitle1" sx={sectionTitleStyle} gutterBottom>b. Academic Information</Typography>
      <ul style={listStyle}>
        <li>Practice Test Scores</li>
        <li>Class Attendance</li>
        <li>Course Progress</li>
        <li>Assessment and Performance Reports</li>
      </ul>

      <Typography variant="subtitle1" sx={sectionTitleStyle} gutterBottom>c. Technical Information</Typography>
      <ul style={listStyle}>
        <li>Device Type and Operating System</li>
        <li>IP Address</li>
        <li>Browser Type</li>
        <li>Location Data (if enabled)</li>
        <li>Pages visited and time spent on the site</li>
      </ul>

      <Typography variant="subtitle1" sx={sectionTitleStyle} gutterBottom>d. Payment Information</Typography>
      <Typography paragraph>
        If you make a payment through <strong>STM</strong>, we may collect payment-related data (handled securely through third-party payment gateways like Razorpay).
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>2. How We Use Your Information</Typography>
      <ul style={listStyle}>
        <li>Create and manage your student profile</li>
        <li>Provide access to courses, materials, and live/offline classes</li>
        <li>Track your performance and provide progress reports</li>
        <li>Send notifications, reminders, and updates</li>
        <li>Improve our website, content, and user experience</li>
        <li>Respond to your inquiries or support requests</li>
        <li>Ensure legal compliance and prevent fraud</li>
      </ul>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>3. Sharing of Information</Typography>
      <Typography paragraph>
        We do not sell your personal data. However, we may share it:
      </Typography>
      <ul style={listStyle}>
        <li>With our internal academic and support teams</li>
        <li>With trusted third-party service providers (e.g., payment gateways, exam platforms)</li>
        <li>With universities or partner organizations (only with your consent)</li>
        <li>With government or law enforcement authorities, if legally required</li>
      </ul>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>4. Cookies and Tracking Technologies</Typography>
      <ul style={listStyle}>
        <li>Understand user behavior on our website</li>
        <li>Personalize content and track performance</li>
        <li>Improve navigation and user experience</li>
      </ul>
      <Typography paragraph>
        You can manage cookie preferences via your browser settings.
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>5. Data Protection and Security</Typography>
      <Typography paragraph>
        We take your data seriously. <strong>STM</strong> uses industry-standard encryption, secure servers, and access control measures to protect your information. However, no online transmission is 100% secure, so we encourage users to be cautious with login credentials and personal data.
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>6. Your Rights</Typography>
      <Typography paragraph>
        As a user, you have the right to:
      </Typography>
      <ul style={listStyle}>
        <li>Access or update your personal information</li>
        <li>Request deletion of your account and data</li>
        <li>Withdraw consent for marketing or communication</li>
        <li>File a complaint regarding misuse or security concerns</li>
      </ul>
      <Typography paragraph>
        To exercise these rights, email us at <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a>.
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>7. Data Retention</Typography>
      <Typography paragraph>
        We retain your data only as long as necessary for educational, legal, and operational purposes. If you request to delete your account, we will securely remove your data from our systems, unless we are legally required to retain it.
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>8. Children’s Privacy</Typography>
      <Typography paragraph>
        Our platform is intended for individuals above 13 years of age. If we become aware that we’ve collected data from a child under 13 without parental consent, we will take immediate steps to delete the data.
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>9. Changes to This Policy</Typography>
      <Typography paragraph>
        <strong>STM</strong> reserves the right to update this Privacy Policy at any time. Any changes will be posted here with a revised "Last Updated" date. We recommend reviewing this page periodically.
      </Typography>

      <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>10. Contact Us</Typography>
      <Typography paragraph>
        For any questions about this Privacy Policy or how your data is handled, please contact:
      </Typography>
      <Typography>
        <strong>STM</strong><br />
        📧 Email: <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a><br />
        📍 Address: A1/153, Ground Floor, Behind Green Fields School, Safdarjung Enclave, New Delhi 110 029
      </Typography>
    </Container>  
    </>
  )
}

export default PrivacyPolicyPage